import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// "월 핫딜 한도" 행의 ⓘ 안내 모달
function PathPickMembershipHotDealLimitInfoModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 가운데 정렬된 모달은 화면보다 넓으면 왼쪽이 잘려 스크롤로도 닿을 수 없다.
      minWidth={"min(560px, 90dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("membership:hot_deal_limit_modal.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"16px"}>
          <Text textStyle={"body-md-medium"} color={"#444440"}>
            {t("membership:hot_deal_limit_modal.description")}
          </Text>
          {/* 확인 버튼 하나만 노출하는 디자인이라 공용 Footer(취소+확인) 대신 자체 푸터로 처리 */}
          <Flex justifyContent={"flex-end"}>
            <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("membership:hot_deal_limit_modal.confirm")}
              </Text>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickMembershipHotDealLimitInfoModal;
